/** Mock ViewModel — schema 1.2.0-sync-activities (hops 0–3 + activities). */
import mock from './order-detail-viewmodel.mock.json';

export default mock;
